import { render } from "./customTemplates.vue?vue&type=template&id=334feb76"
import script from "./customTemplates.vue?vue&type=script&lang=js"
export * from "./customTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__